module.exports = __webpack_public_path__ + "static/assets/4821bcce8d07e55dfec6d5dee576b6bd.png";